export type WorkspaceAgentSessionRunningState = {
  activeRunId: string | null;
  isAwaitingRunStart: boolean;
  isSending: boolean;
  isSessionProcessing: boolean;
};

export const isWorkspaceAgentSessionRunning = ({
  activeRunId,
  isAwaitingRunStart,
  isSending,
  isSessionProcessing,
}: WorkspaceAgentSessionRunningState): boolean =>
  isSending || activeRunId !== null || isSessionProcessing || isAwaitingRunStart;
